export const entities = [
    {
        name: 'IndicatorKey',
        fields:[
            'IndicatorKeyList',
            'objectif'
        ],
    },
    {
        name: 'IndicatorKeyList',
        facets: [{name: 'codeName', uniqueCode: true}],
    }
]


export const module_ = {
    object: 'IndicatorKeyList',
    tKey: 'Indicateur',
    category: {
        path: 'paramétrage',
        icon: 'settings'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            'code',
            'name'
        ],
        form: [
            'code',
            'name'
        ]
    }
}